import Alert from "@/component/alert";
import TextInfo, { TEXT_COLOR, TEXT_FONT_WEIGHT, TEXT_SIZE } from "@gc-npm/components.text";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";
import style from "./style";
import { useSelector } from "react-redux";

const AlertNewR2R = ({ type = "devices-list" }) => {
    //use selector products
    const { isUserNewModelR2R, userDiscountNewModelR2R } = useSelector(
        (state) => state.getMyProducts
    );


    return (
        isUserNewModelR2R && userDiscountNewModelR2R && (
            <div className="alert-container">
                <Alert
                    sx={{
                        backgroundColor: getColor(COLOR_DICTIONARY.GREEN_200),
                        border: `1px solid ${getColor(COLOR_DICTIONARY.GREEN_200)}`,
                        padding: "1rem 16px",
                    }}
                    icon={{
                        name: "navidad-regalo-m",
                        color: COLOR_DICTIONARY.GREEN_DARK,
                        withBackground: false,
                        height: '24',
                        flexAlign: 'flex-start',
                    }}>
                    <div className="alert-content">
                        <TextInfo
                            text={`<b>Tu descuento exclusivo de ${userDiscountNewModelR2R} €</b>`}
                            size={TEXT_SIZE.TEXT_PRESET_03}
                            color={TEXT_COLOR.GREEN_DARK}
                            fontType={TEXT_FONT_WEIGHT.REGULAR}
                        />
                        <TextInfo
                            text={`Ya aplicado en el precio`}
                            size={TEXT_SIZE.TEXT_PRESET_02}
                            color={TEXT_COLOR.GREEN_DARK}
                            fontType={TEXT_FONT_WEIGHT.REGULAR}
                        />
                    </div>
                </Alert>
                <style jsx>{style}</style>
            </div>
        )
    );
};

export default AlertNewR2R;
